var map = {
	"./arm-articulated-claw.png": 3767,
	"./arm-dual-claw.png": 1220,
	"./arm-grabber.png": 2762,
	"./arm-propeller.png": 5700,
	"./arm-stubby-claw.png": 8811,
	"./base-double-wheel.png": 1190,
	"./base-rocket.png": 3336,
	"./base-single-wheel.png": 829,
	"./base-spring.png": 6960,
	"./base-triple-wheel.png": 2993,
	"./head-big-eye.png": 4646,
	"./head-friendly.png": 7030,
	"./head-shredder.png": 7672,
	"./head-single-eye.png": 4434,
	"./head-surveillance.png": 2798,
	"./torso-flexible-gauged.png": 2544,
	"./torso-gauged.png": 5655,
	"./torso-pouch.png": 5512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1597;